'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PresenceGroupChildContext: function() {
        return PresenceGroupChildContext;
    },
    PresenceGroupChildProvider: function() {
        return PresenceGroupChildProvider;
    },
    usePresenceGroupChildContext: function() {
        return usePresenceGroupChildContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const PresenceGroupChildContext = _react.createContext(undefined);
const PresenceGroupChildProvider = PresenceGroupChildContext.Provider;
const usePresenceGroupChildContext = ()=>_react.useContext(PresenceGroupChildContext);
